import { dxUiCustom } from '@/utils/dx-helper';

const AiCustomConfirmDialog = async (message, title = 'Подтвердите действие', hasButtons = true, showCancel = true) => {
    const dialogPromise = new Promise(resolve => {
        const buttons = [{ text: 'Да', onClick: () => resolve(1) }]
          .concat(hasButtons && [{ text: 'Нет', onClick: () => resolve(0) }]
                .concat(showCancel && [{ text: 'Отмена', onClick: () => resolve(-1) }] || []) || [])
        const options = {
            title,
            messageHtml: `<div class="text-center">${message}</div>`,
            buttons,
            showTitle: true,
            dragEnabled: false,
        };

        const dialog = dxUiCustom(options);
        dialog.show();
    });

    return await dialogPromise;
};

export default AiCustomConfirmDialog;
